import CorporateLeads from './CorporateLeads';

export default CorporateLeads;
